import React from "react";
import Form from "./Form";

const Nav = () => {
  return (
    <nav>
      <Form />
    </nav>
  );
};

export default Nav;
